import { useCallback, useMemo, useState } from "react";

import type { INotificationsContext } from "../context/NotificationsContext";
import { NotificationsContext } from "../context/NotificationsContext";

interface INotificationsProviderProps {
  children: React.ReactNode;
}

export const NotificationsProvider = ({
  children,
}: INotificationsProviderProps): React.JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);

  const openDrawer = useCallback((): void => {
    setIsOpen(true);
  }, []);

  const closeDrawer = useCallback((): void => {
    setIsOpen(false);
  }, []);

  const value = useMemo<INotificationsContext>(
    () => ({ isOpen, openDrawer, closeDrawer }),
    [isOpen, openDrawer, closeDrawer],
  );

  return (
    <NotificationsContext.Provider value={value}>
      {children}
    </NotificationsContext.Provider>
  );
};
